import '../assets/cssFiles/app.css';

import React from 'react';

import Routes from '../route/router';

import Header from '../components/Header';
import Footer from '../components/Footer';

export default function App() {
  return (
    <div className="App">
        <Header/>
        <Routes/>
        <Footer/>
    </div>
  );
}